module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/oval-75f57277443e20df9b43b2eb6bc2d8d7.svg";